import TextAreaLine from './TextAreaLine.vue';

TextAreaLine.install = (Vue) => {
  Vue.component(TextAreaLine.name, TextAreaLine);
};

export default TextAreaLine;
